import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useFormatter from '../../common/useFormatter';
import { getAssignmentMetricDescriptorsMap } from './assignmentMetric.default';
import {
  AssignmentMetric,
  AssignmentMetricDescriptor,
} from './assignmentMetric.types';

function useAssignmentMetricDescriptorsMap() {
  const { t } = useTranslation('app');
  const formatter = useFormatter();
  // const extraDescriptors = useRecoilValue(actualityExtraMetricDescriptors);

  const metrics: AssignmentMetricDescriptor[] = [
    {
      ...getAssignmentMetricDescriptorsMap(t).stockUom,
      category: 'stockUom',
      title: t`Stock UOM`,
    },
    {
      ...getAssignmentMetricDescriptorsMap(t).stockUomQuantity,
      category: 'stockUom',
      title: t`Stock UOM Quantity`,
    },

    // ...(extraDescriptors as any),
  ];

  const titled = _(metrics)
    .map(d => ({ ...d, titleCategory: t`Stock Stats`, subTitle: t`Item` }))
    .keyBy(d => d.type)
    .value() as Record<AssignmentMetric, AssignmentMetricDescriptor>;
  return titled;
}

export default useAssignmentMetricDescriptorsMap;
